import React from 'react';
import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';


const BarnDoors = ({ show, duration }) => {
  const transitionStyles = {
    transition: `all ${duration}ms cubic-bezier(0.215, 0.61, 0.355, 1)`,
  };

  return (
    <CSSTransition in={show} timeout={duration} classNames="barn-doors" appear unmountOnExit>
      <div className="h-100 barn-doors">
        <div className="barn-doors-left" style={transitionStyles} />
        <div className="barn-doors-right" style={transitionStyles} />
      </div>
    </CSSTransition>
  );
};

BarnDoors.propTypes = {
  in: PropTypes.bool,
  duration: PropTypes.number,
};

export default BarnDoors;



// WEBPACK FOOTER //
// ./src/components/Covers/BarnDoors.js